import { DbDeleteReceipt } from "../../../data/usecases/delete-receipt";
import { DeleteReceipt } from "../../../domain/usecases/delete-receipt";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbDeleteReceipt = (): DeleteReceipt =>
  new DbDeleteReceipt(
    makeApiUrl("/receipt"),
    makeAuthorizeHttpClientDecorator()
  );
